import { render, staticRenderFns } from "./LandingPageNavbar.vue?vue&type=template&id=642b7033&scoped=true&"
import script from "./LandingPageNavbar.vue?vue&type=script&lang=js&"
export * from "./LandingPageNavbar.vue?vue&type=script&lang=js&"
import style0 from "./LandingPageNavbar.vue?vue&type=style&index=0&id=642b7033&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "642b7033",
  null
  
)

export default component.exports